import { useMemo } from 'react';
import { useT, useTX } from '@transifex/react';
import { getTxInstance } from '@flow/libs/utils/tx';
import type { TContext, TFunction } from '@app/components/translation';
import { useTranslationsIsReady } from '@app/hooks/use-tx-translations-loader';

type TranslationsLoader = {
  isReady: boolean;
  t: TFunction;
  tx: TContext;
};

type UseDocumentTranslationsLoaderProps = {
  isGuest: boolean;
  language: string;
};

const DOCUMENT_TRANSLATIONS_SCOPE = 'DOCUMENT_TRANSLATIONS';

export const useDocumentTranslationsLoader = ({
  language,
  isGuest,
}: UseDocumentTranslationsLoaderProps): TranslationsLoader => {
  const defaultInstance = useTX();
  // biome-ignore lint/correctness/useExhaustiveDependencies: The memo needs to be memoized
  const tx = useMemo(() => {
    if (isGuest) {
      return defaultInstance;
    }

    return getTxInstance(DOCUMENT_TRANSLATIONS_SCOPE);
  }, [
    isGuest,
  ]);
  const t = useT(tx);
  const isReady = useTranslationsIsReady(tx, language);

  return {
    isReady,
    t,
    tx,
  };
};
